// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.CoursesWholeContainer{

   
}
.CoursesWholeforewording{
    padding: 30px;
    background-color: rgb(114, 158, 114);
    color: white;
}


.HeadingFilter{

    display: flex;
    align-items: center;
    gap: 10px;
}

.CoursesWholeforewording{
    /* height: 220px; */
    /* background-color: red; */
}

.moreWordingContainer{
    /* background-color: gray; */
    max-width: 500px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/CoursesWhole/CoursesWhole.css"],"names":[],"mappings":";;AAEA;;;AAGA;AACA;IACI,aAAa;IACb,oCAAoC;IACpC,YAAY;AAChB;;;AAGA;;IAEI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;AACpB","sourcesContent":["\n\n.CoursesWholeContainer{\n\n   \n}\n.CoursesWholeforewording{\n    padding: 30px;\n    background-color: rgb(114, 158, 114);\n    color: white;\n}\n\n\n.HeadingFilter{\n\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.CoursesWholeforewording{\n    /* height: 220px; */\n    /* background-color: red; */\n}\n\n.moreWordingContainer{\n    /* background-color: gray; */\n    max-width: 500px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
